(function () {
  let swiper;

  const initSlider = () => {
    const slider = document.querySelector(".swiper-container");
    if (!slider || slider.classList.contains("slider_started")) {
      return;
    }
    slider.classList.add("slider_started");
	let loop  
	if(slider.dataset.loop === "true") {
		loop = true
	} else if(slider.dataset.loop === "false") {
		loop = false
	}


    swiper = new Swiper(".swiper-container", {
      slidesPerView: 1,
      speed: 650,
      spaceBetween: 2,
			loop: loop,
      navigation: {
        nextEl: ".product-button-group .swiper-button-next-1",
        prevEl: ".product-button-group .swiper-button-prev-1",
      },
      pagination: {
        el: ".product-card-pagination",
        clickable: true,
      },
    });
document.addEventListener('mouseover', (event) => {
    const buttonNext = event.target.closest('.button-next');
    if (buttonNext) {
        const swiperButton = buttonNext.querySelector('.swiper-button-next-1');
        const cursor = buttonNext.querySelector('.product__cursor');
        if (swiperButton?.classList.contains('swiper-button-disabled') && cursor) {
            cursor.style.opacity = '0.5';
        }
    }
});
		const cursorProgress = (productSwiper) => {
			const cursor = productSwiper.querySelector(".product__cursor");
			const cursorIcon = productSwiper.querySelector("#cursor-icon1");
		
			const animateCursor = (e) => {
				const contentRect = productSwiper.getBoundingClientRect();
				const x = e.clientX - contentRect.left - 12;
				const y = e.clientY - contentRect.top - 12;
		
				cursor.animate(
					{ transform: `translate(${x}px, ${y}px)` },
					{ duration: 300, fill: "forwards" }
				);
			};
		
			const getCursorClass = (position, width) => {
				return position < width / 2 ? "prev" : "next";
			};
		
			productSwiper.addEventListener("mousemove", (e) => {
				if (!e.target.closest(".link") &&
				!e.target.closest(".swiper-pagination") ) {
					cursor.classList.add("active");
				} else {
					cursor.classList.remove("active");
				}
		
				animateCursor(e);
		
				const position = e.clientX - productSwiper.getBoundingClientRect().left;
				cursor.dataset.type = getCursorClass(position, productSwiper.clientWidth);
		
				cursorIcon.className = cursor.dataset.type; 
		
				
			});
		
			productSwiper.addEventListener("mouseleave", () => {
				cursor.classList.remove("active");
			});
		};
		

    const productCards = document.querySelectorAll(".card--product_cursor");
    productCards.forEach((productCard) => cursorProgress(productCard));
  };

  initSlider();
  document.addEventListener("shopify:section:load", initSlider);
	
})();
